import api from './api';

export const get = query => api.get(`/enterprise${query}`);

export default get;
